import dedent from 'ts-dedent'
import {
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { SelectWorkflowComponent } from './common/selectcomponent'

class BoundingBoxFromValues extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.bboxfromvalues',
        group: 'Spatial Constructors',
        title: 'BBOX from Values',
        description: `
      This component creates a new table containing a 'geom' column and a single row
      containing a geography that represents a bounding box as defined by the input min/max values.
      `
      },
      [
        {
          name: 'xmin',
          type: WorkflowComponentParamType.Number,
          title: 'Minimum X',
          min: -180,
          max: 180,
          default: 10
        },
        {
          name: 'ymin',
          type: WorkflowComponentParamType.Number,
          title: 'Minimum Y',
          min: -90,
          max: 90,
          default: 10
        },
        {
          name: 'xmax',
          type: WorkflowComponentParamType.Number,
          title: 'Maximum X',
          min: -180,
          max: 180,
          default: 20
        },
        {
          name: 'ymax',
          type: WorkflowComponentParamType.Number,
          title: 'Maximum Y',
          min: -90,
          max: 90,
          default: 20
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    const xmin = params.xmin
    const xmax = params.xmax
    const ymin = params.ymin
    const ymax = params.ymax
    switch (connection.type) {
      case Provider.BigQuery:
      case Provider.Snowflake:
        return dedent`SELECT ST_GEOGFROMTEXT(
            'POLYGON((${xmin} ${ymin}, ${xmin} ${ymax}, ${xmax} ${ymax}, ${xmax} ${ymin}, ${xmin} ${ymin}))'
          ) geom`
      case Provider.Postgres:
      case Provider.Redshift:
        return dedent`SELECT ST_GEOMFROMTEXT(
                'POLYGON((${xmin} ${ymin}, ${xmin} ${ymax}, ${xmax} ${ymax}, ${xmax} ${ymin}, ${xmin} ${ymin}))'
              ) geom`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40, geom) */ ${connection.processOutputGeogColumn(`ST_GEOGFROMTEXT(
            'POLYGON((${xmin} ${ymin}, ${xmin} ${ymax}, ${xmax} ${ymax}, ${xmax} ${ymin}, ${xmin} ${ymin}))'
          )`)} geom`
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ connection }: GetOutputSchemaParams): TableSchema {
    return [
      {
        name: 'geom',
        type: connection.getGeoDataType()
      }
    ]
  }
}

export { BoundingBoxFromValues }
